import Rx from 'rx';

export default function MemberBoardCtrl($scope, $wamp, progressBar) {

  progressBar.add('board');

  let reportsSubscription = Rx.Observable.fromPromise($wamp.call('org.eggs.get_board_of_directors'))
    .safeApply($scope, function (board) {
      progressBar.remove('board');
      const members = board.filter(obj => obj.executive === false);
      const executive = board.filter(obj => obj.executive === true);

      let orderBy = ['Chairman', 'Vice Chairman', 'Treasurer', 'Secretary', 'Past Chairman', 'None', ''];

      function customSort(a, b) {
        return orderBy.indexOf(a.title) - orderBy.indexOf(b.title);
      }

      $scope.board = {
        members,
        executive: executive.sort(customSort).map(e => {
          e.title = e.title ? e.title + ':' : '';
          return e;
        })
      };
    }).subscribe();

}
